import { UserPhotoIcon } from '@investoro/core';

export default UserPhotoIcon;
